import type { ReceivableCounts } from '@klear/invoice-offer/receivables'
import type { ReceivableRow } from '@klear/order-event/receivable'
import { trpc } from '@klear/ui/lib/trpc'

const NO_ROWS: ReceivableRow[] = []
const NO_COUNTS: ReceivableCounts = { quotes: 0, awaitingQuote: 0, pending: 0, live: 0, total: 0 }

export function useReceivables(
  traderId: number,
  { enabled = true, completed = false }: { enabled?: boolean; completed?: boolean } = {}
) {
  const { data, isLoading, error } = trpc.receivable.list.useQuery(completed ? { traderId, completed } : { traderId }, {
    enabled: enabled && traderId > 0
  })
  return { rows: data?.rows ?? NO_ROWS, counts: data?.counts ?? NO_COUNTS, isLoading, error }
}
